import { Card, CardContent, Stack, Typography } from '@mui/material';
import FilterBarFilters from './FilterBarFilters';
import FilterBarSearchInput from './FilterBarSearchInput';
import type { FilterBarProps } from './contracts';
import { mergeSx } from 'framework/utils';

const FilterBar = ({
  searchProps,
  filterProps,
  totalRecords,
  totalRecordsLabel = 'Total records',
  sx,
}: FilterBarProps) => {
  if (!searchProps && !filterProps && totalRecords === undefined) {
    return null;
  }

  return (
    <Card sx={mergeSx({ width: '100%', p: 1 }, sx)}>
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" flexWrap="wrap" useFlexGap rowGap={1}>
          <Stack direction="row" alignItems="center" spacing={2} flexWrap="wrap" useFlexGap>
            {searchProps && <FilterBarSearchInput {...searchProps} />}
            {filterProps && <FilterBarFilters {...filterProps} />}
          </Stack>
          {totalRecords !== undefined && (
            <Typography color="textSecondary" sx={{ flexShrink: 0 }}>
              {totalRecordsLabel}: {totalRecords}
            </Typography>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
};

export default FilterBar;
